import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import store from '@/store';
import EditableText from '@/components/EditableText/EditableText.vue';
import BaseLayersTreeItem from '../BaseLayersTreeItem.vue';
import type { ListElements } from '@/typings/customilyElements/layer';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersTreeItemEps',
  props: {
    item: null,
    collapsed: { type: Boolean }
  },
  emits: ['toggle-collapse'],
  setup(__props: any, { emit }) {

const props = __props as {
    item: ListElements;
    collapsed?: boolean;
};





const { flags, onElementTitleChange } = useLayerTreeItem({
    item: props.item
});

const pageEpsElements = computed(() => {
    return store.state.storeLayers?.rawElements.pageEpsElements;
});

const hideWrapper = computed(() => {
    return pageEpsElements.value && pageEpsElements.value?.length <= 1;
});

const onCollapseClick = () => {
    emit('toggle-collapse');
};

return { __sfc: true,emit, props, flags, onElementTitleChange, pageEpsElements, hideWrapper, onCollapseClick, EditableText, BaseLayersTreeItem }
}

})